<div class="flex-row flex-fill align-items-end">
  <div class="flex-child d-flex justify-content-center">
    <button
      mat-button
      class="custom-button"
      [disabled]="status !== 'default'"
      (click)="openEnergyDialog()"
      aria-haspopup="dialog"
      [attr.aria-label]="accessibilityLabel | translate"
    >
      <span>{{
        "ENERGY_COCKPIT.ENERGY_CHART.BUTTON_LABEL." + type | translate
      }}</span>
      <mat-icon
        *ngIf="series"
        class="chevron-icon"
        svgIcon="chevron_right"
      ></mat-icon>
    </button>
  </div>
</div>
